import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlSnrCaseFieldsFragment = { id: string, filingYear: string, filingNumber: string, arrivalDate?: string | null, registrationDate?: string | null, companyId: string, createdAt: string, updatedAt: string, status: Array<{ kod: string, value: string }>, subjects: Array<{ value: string, kind: Types.GqlSnrCaseSubjectKind }> };

export const SnrCaseFieldsFragmentDoc = gql`
    fragment SnrCaseFields on SnrCase {
  id
  filingYear
  filingNumber
  arrivalDate
  registrationDate
  status {
    kod
    value
  }
  subjects {
    value
    kind
  }
  companyId
  createdAt
  updatedAt
}
    `;